import { LIDiscountReportField } from "src/app/enums/Report/ReportField/Discount/LIDiscountReportField";
import { ReportSortDefinition } from "../Components/IReportSortDefinition";
import { DateRangeParameter } from "./DateRangeParameter";
import { BaseReportParameters } from "./BaseReportParameters";

const localStorageFormParametersProperty = 'DiscountReportParameters';

export class DiscountReportParameters extends BaseReportParameters {
  reportGroup: LIDiscountReportField;
  posId: number;
  clerkId: number;
  salesDateRange: DateRangeParameter;
  sort: ReportSortDefinition[];

  constructor() {
    super(localStorageFormParametersProperty);
  }

  protected getParameters(storedParameters: DiscountReportParameters) {
    this.reportGroup = <LIDiscountReportField>(storedParameters?.reportGroup ?? LIDiscountReportField.None);
    this.posId = storedParameters?.posId ?? -1;
    this.clerkId = storedParameters?.clerkId ?? -1;
    this.salesDateRange = new DateRangeParameter(storedParameters?.salesDateRange);
  }
}
